import CurrentRefinements from '@/presentation/components/modules/filters/CurrentRefinements';
import Nfts, { NftsProps } from './Nfts';
import { useNetwork } from '@/presentation/context/network';
import Filters from '@/presentation/components/modules/filters/Filters';

type NftsContainerProps = Omit<
  NftsProps,
  'hasFilters' | 'currentRefinements' | 'filters' | 'chainSlug'
> & {
  filters: {
    key: string;
    value: string[];
    count: number;
    options: { value: string; count: number }[];
  }[];
  onFilter: (key: string, value: string) => void;
};

const NftsContainer = ({ filters, onFilter, ...props }: NftsContainerProps) => {
  const hasFilters = filters.some((f) => f.count > 0);
  const { slug: chainSlug } = useNetwork();

  return (
    <Nfts
      {...props}
      chainSlug={chainSlug}
      hasFilters={hasFilters}
      currentRefinements={
        <CurrentRefinements filters={filters} onFilter={onFilter} />
      }
      filters={<Filters filters={filters} onFilter={onFilter} />}
    />
  );
};

export default NftsContainer;
